if (!customElements.get('seo-link-columns')) {
  class SeoLinkColumns extends HTMLElement {
    connectedCallback() {
      this.columns = this.querySelectorAll('details');
      this.desktopQuery = window.matchMedia('(min-width: 768px)');
      this.onToggle = this.handleToggle.bind(this);
      this.onViewportChange = this.syncDesktopState.bind(this);
      this.columns.forEach((column) => {
        column.addEventListener('toggle', this.onToggle);
      });
      this.desktopQuery.addEventListener('change', this.onViewportChange);
      this.syncDesktopState();
    }

    disconnectedCallback() {
      this.columns.forEach((column) => {
        column.removeEventListener('toggle', this.onToggle);
      });
      this.desktopQuery.removeEventListener('change', this.onViewportChange);
    }

    syncDesktopState() {
      if (!this.desktopQuery.matches) return;
      this.columns.forEach((column) => {
        column.open = true;
      });
    }

    handleToggle(event) {
      if (this.desktopQuery.matches) {
        event.target.open = true;
        return;
      }
      if (!event.target.open) return;
      this.columns.forEach((column) => {
        if (column !== event.target) column.open = false;
      });
    }
  }

  customElements.define('seo-link-columns', SeoLinkColumns);
}
